import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {User} from "types/User"

type ReturnedType = {
    status: "success"
    users: User[]
}

export const fetchStaffUsers = createAsyncThunk<ReturnedType, undefined, AppThunkProps>(
    "staff/users/fetch",
    async (_, {signal}) => {
        return api.get<ReturnedType>("/user/users", {signal})
    },
    {
        condition(_, {getState}) {
            const {staff} = getState()
            return !staff.ids.length
        }
    }
)
